<script>
export default {
  name: "ViewDocuments",

  data() {

return {
    errors: [],
    inv: {
      claimNo: ``
    },
    doc: {
      name: `Supplier Payment`
    },
    supplierDocuments:[],
    active: 0,
};
},
methods:{
    AddDocumentForm(){
        if(this.active==0){
            this.active=1;
        }else{
            this.active=0;
        }

    },
    saveDocument() {
            this.$root.loading = true;
            const file = this.$refs.file.files[0];
            let url = `Files/PostSupplierPaymentDocument`;
            url += `?ID=0`;
              url += `&RemittanceNo=${this.claim.remittanceNo}`;
             url += `&DocName=${this.doc.name}`;
            url += `&UserName=${this.$root.username}`;
            url += `&contentType=${file.type}`;
            const fileData = new FormData();
            fileData.append('file', file);
            this.$http.post(url, fileData).then(({ data }) => {
              this.$refs.file.value = null;
              this.doc = { name: ``, };
             // this.$emit('refresh');
             this.fetchClaimDocuments();
              window.Swal.fire({ type: `success`, text: data });
             // this.$emit('closeModal');
              this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
      },
      fetchRemittanceDocuments(remittanceNo) {
        this.$root.loading = true;
        let url = `SupplierPayments/GetSupplierPaymentDocument`;
            url += `?RemittanceNo=${remittanceNo}`;
        this.supplierDocuments = [];
        return this.$http.get(url).then(({data}) => {
            this.supplierDocuments = data;
            this.$root.loading = false;
            return Promise.resolve();
        }).catch(() => { this.$root.loading = false; return Promise.reject(); });
    },
},

  props: {
    showModal: Boolean,
    documents: Array,
    claim: Object,
  },
};
</script>
<template>
  <tail-modal :show="showModal" dimension="w-10/12">
    <template v-slot:title>
      <h5 class="font-medium text-sm">Supplier Payment Documents</h5>
    </template>
    <template v-slot:modal-body>
      <div class="w-full flex flex-wrap items-center">
        <div class="w-full flex flex-wrap p-2 bg-gray-300 mb-2">
          <!-- <div class="flex-1">
            <h5 class="font-medium text-sm">
              Patient: {{ claim.patientName }}{{ active }}
            </h5>
          </div> -->
          <div class="flex-1">
            <h5 class="font-medium text-sm">Remittance No: {{ claim.remittanceNo }}</h5>
          </div>
          <div class="flex-1">
            <h5 class="font-medium text-sm">Claim No: {{ claim.claimNo }}</h5>
          </div>
          <div class="flex-1">
            <h5 class="font-medium text-sm">Date: {{ (claim.trxDate || claim.date ) | dateFormat }}</h5>
          </div>
          <div class="flex-1">
            <div class="w-full p-2 bg-gray-300 text-right">
        <button 
            @click.prevent="AddDocumentForm"
            class="btn-sm btn-primary text-sm rounded">Add Document</button>
    </div>
          </div>
        </div>
        <div class="w-full flex flex-wrap items-center">
            <form v-show="active === 1"
                id="form-upload"
                @submit.prevent="saveDocument"
                class="w-full flex flex-wrap items-center"
              >
                 
                 
            <div class="md:w-1/3 w-full p-1">
                  <label for="grid-file" class="label-control">Document:</label>
                  <input
                    type="file"
                    ref="file"
                    id="grid-file" required
                    class="input-control input-sm text-xs"
                  />
                </div>
                <div class="w-1/12 text-right mt-2">
                    <button v-if="active === 1"
            form="form-upload"
            type="submit"
            class="btn-primary btn-sm text-xs rounded"
          >
            <i class="fa fa-upload"></i> Upload Document
          </button>
            </div>
              </form>
              
              <div class="md:w-1/3 w-full p-tiny">   
          </div>
        </div>
        
        <div class=" flex flex-col items-center w-full p-1 my-2" v-for="claimDoc in documents" :key="claimDoc.id">
            <h5 class="font-medium text-sm my-1">Name: {{claimDoc.docName}}</h5>
            <iframe
              v-if="claimDoc.contentType == `application/pdf`"
              :src="`data:application/pdf;base64,${claimDoc.document}`"
              height="800"
              width="1000"
            ></iframe>
            <img
              v-else
              :src="`data:application/image;base64,${claimDoc.document}`"
              :alt="claimDoc.docName"
            />
        </div>
      </div>
    </template>
    <template v-slot:modal-footer>
      <button
        class="btn-danger btn-sm text-xs rounded"
        @click.prevent="$emit(`closeModal`)"
      >
        <i class="fa fa-times"></i> Close
      </button>
    </template>
  </tail-modal>
</template>
